module.exports = __webpack_public_path__ + "img/ic-money-1.65886ef0.png";